import { Table, TableContainer, Tbody, Th, Thead, Tr } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import OpenedPositionTableRow from './OpenedPositionTableRow';

interface Props {
  items: PortfolioPositionItem[];
}

const OpenedPositionsTable: FC<Props> = ({ items }) => {
  const { t } = useTranslation();

  return (
    <TableContainer w="100%">
      <Table >
        <Thead>
          <Tr>
            <Th>{t('openedPositionsTableTicker')}</Th>
            <Th>{t('openedPositionsTableQuantity')}</Th>
            <Th>{t('openedPositionsTableCurrentPrice')}</Th>
            <Th>{t('openedPositionsTableResult')}</Th>
            <Th>{t('openedPositionsTableTotalValue')}</Th>
          </Tr>
        </Thead>
        <Tbody>
          {items.map((item, index) => (
            <OpenedPositionTableRow
              key={index}
              {...item}
            />
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export default OpenedPositionsTable;
